import { OutlinedInput } from "@mui/material";

/**
 * CustomInput
 */

type Props = {
  value: string;
  readOnly?: boolean;
  onValueChange: (newValue: string) => void;
};

export const CustomInput = ({
  value,
  readOnly,
  onValueChange,
}: Props) => {
  return (
    <OutlinedInput
      size="small"
      value={value ?? ""}
      fullWidth={true}
      readOnly={readOnly}
      onKeyDown={(e) => {
        if (e.code === "Space" || e.key === " ") {
          e.stopPropagation();
        }
      }}
      onChange={(e) => { if (!readOnly) { onValueChange(e.target.value) } }}
      slotProps={{
        root: {
          style: {
            padding: '.2rem .4rem',
          },
        },
        input: {
          style: {
            padding: '.0rem .1rem',
          },
        }
      }}
    />
  );
}